<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Forma de impresión</span>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/twoSided/1-side.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">A una cara</span>
      <span class="section_info">Cada página de tu documento se imprimirá solo por una cara del folio.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/twoSided/2-sides.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">A doble cara</span>
      <span class="section_info">Las páginas de tu documento se imprimirán por ambas caras del folio.</span>
    </div>
  </div>
</div>
